function getClientX(event) {
  if (event.type?.startsWith('touch')) {
    const touchPositions = [...event.touches].map((touch) => touch.clientX)
    return (
      touchPositions.reduce((sum, touch) => sum + touch) / touchPositions.length
    )
  }
  return event.clientX
}

export default {
  data: () => ({
    dragging: false,
    dragStartFrame: null,
    dragOffset: null,
    dragWidth: null,
    dragRotationsPerWidth: 2, // Rotate the product this many times if the mouse is dragged all the way from one side to the other
  }),
  mounted() {
    this.dragMove = this.throttleFunction(this.dragMove, 100)
    this.addMouseListeners()
  },
  destroyed() {
    this.removeMouseListeners()
  },
  methods: {
    addMouseListeners() {
      this.$el.addEventListener('touchstart', this.startDrag, { passive: true })
      this.$el.addEventListener('mousedown', this.startDrag)
      window.addEventListener('touchend', this.stopDrag, { passive: true })
      window.addEventListener('mouseup', this.stopDrag)
    },
    removeMouseListeners() {
      this.$el.removeEventListener('touchstart', this.startDrag)
      this.$el.removeEventListener('mousedown', this.startDrag)
      window.removeEventListener('touchend', this.stopDrag)
      window.removeEventListener('mouseup', this.stopDrag)
      window.removeEventListener('touchmove', this.dragMove)
      window.removeEventListener('mousemove', this.dragMove)
    },
    startDrag(event) {
      if (this.disable360) return

      this.dragging = true
      this.dragStartFrame = this.frameNumber
      this.dragOffset = getClientX(event)
      this.dragWidth = event.target.getBoundingClientRect().width

      window.addEventListener('touchmove', this.dragMove, { passive: true })
      window.addEventListener('mousemove', this.dragMove)
    },
    stopDrag() {
      this.dragging = false

      window.removeEventListener('touchmove', this.dragMove)
      window.removeEventListener('mousemove', this.dragMove)
    },
    dragMove(event) {
      const distance = this.dragOffset - getClientX(event)
      const distanceRatio = distance / this.dragWidth
      const frameDelta = Math.round(
        this.dragRotationsPerWidth * this.frameCount * distanceRatio
      )
      requestAnimationFrame(() => {
        this.frameNumber = this.getFrameNumber(this.dragStartFrame + frameDelta)
      })
    },
  },
}
